import { type DateKey, numberForDate } from '@arrow/game-engine';

import { browserStore, type KeyValueStore } from '../storage/kv.ts';
import { readScheduleStart } from '../storage/schedule-start.ts';

/**
 * The daily number of `date`, from where the schedule starts as last seen from the api
 * (storage/schedule-start.ts: the archive's No. 1, or worked out from any daily), so a
 * past day's number needs no fetch. Null before the start, or while it isn't known yet.
 *
 * No constant here: the api's SCHEDULE_START is only a fresh database's default, and an
 * environment's No. 1 is whatever its schedule says (2026-10-25 on the test environment
 * since the numbering reset; launch day on production).
 */
export function dailyNumberOf(date: DateKey, store: KeyValueStore = browserStore()): number | null {
	const start = readScheduleStart(store);
	return !start || date < start.date ? null : numberForDate(date, start);
}
